import { connect } from 'react-redux';
import StaffList from "./StaffList";
import {
    fetchGetStaffMembers, getStaffMembersData, getStaffMemberToRemove, loadingStaffMembers,
    setStaffMemberToRemove, removeStaffMember
} from "../../../reducers/organization/staffMembers";
import _ from 'lodash';
import {MODAL_NEW_STAFF_MEMBER, MODAL_REMOVE_STAFF_MEMBER, MODAL_RESENT_ACTIVATION_STAFF_MEMBER, MODAL_CHANGE_ANCHOR, showModal} from "../../../reducers/common/activeModal";
import {getTranslation} from "../../../reducers/common/localization";

const mapStateToProps = state => {
    return {
        loading: loadingStaffMembers(state),
        translation: getTranslation(state),
        data: getStaffMembersData(state),
        removingMode: !_.isNil(getStaffMemberToRemove(state))
    };
};


const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetStaffMembers());
        },
        onStaffMemberAdd: () => dispatch(showModal({modalKey: MODAL_NEW_STAFF_MEMBER})),
        onStaffMemberRemove: (staffMemberId) => {
            dispatch(showModal({modalKey: MODAL_REMOVE_STAFF_MEMBER}));
            dispatch(setStaffMemberToRemove(staffMemberId));
        },
        onChangeAnchor: () => dispatch(showModal({modalKey: MODAL_CHANGE_ANCHOR})),
        onRemove: () => dispatch(removeStaffMember()),
        onResendActivation : () => dispatch(showModal({modalKey: MODAL_RESENT_ACTIVATION_STAFF_MEMBER}))
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(StaffList);



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/staffList/StaffList.container.js